const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/StartPage/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        startTitle: 'Willkommen',
        loginBtnLabel: 'Login',
        loginWithCodeBtnLabel: 'Login mit Aufgebot',
        createProfileBtnLabel: 'Profil erstellen',
        regsitration: 'Registrieren',
        welcomeText:
            'Mit dem Patientenportal von <b>{hospitalName}</b> behalten Sie stets den Überblick über Ihre Spitaltermine und haben jederzeit Zugriff auf alle wichtigen Informationen rund um Ihre Gesundheit.',
        loginText: 'Ich habe bereits ein Konto',
        register: 'Ich möchte mich registrieren',
        smsCodeMissing: 'Bitte geben Sie den erhaltenen Code ein',
        smsCodeBad: 'Dieser Code ist nicht gültig',
        QRCodeWithInvitationCode: 'Bitte den QR-Code einscannen',
        withAufgebot: 'mit Aufgebot',
        withLogin: 'mit Login',
        modalTitle: 'Welcher Fall trifft auf Sie zu?',
        noSMSCodeTitle: 'Sie haben keinen SMS-Code an die angezeigte Nummer erhalten?',
        noSMSCodeText:
            'Die angezeigte Nummer ist korrekt, aber Sie haben keinen SMS-Code erhalten?\nBitte gehen Sie zurück zur Startseite und versuchen Sie, sich erneut anzumelden',
        goBackBtn: ' zurück zur Startseite',
        registeredAndNoSMSTitle: 'Sie haben trotz erneuter Anmeldung keinen SMS-Code erhalten?',
        registeredAndNoSMSText:
            'Wenn Sie sich erneut angemeldet und immer noch keine SMS erhalten haben,\nnehmen Sie bitte Kontakt auf.',
        contactDetailsBtn: ' zu den Kontaktdaten',
        wrongNumberTitle: 'Ist die nummer falsch, unbekannt oder haben sie keinen Zugriff mehr darauf?',
        wrongNumberText:
            'Wenn Ihnen die Nummer unbekannt ist, Fehler aufweist oder Sie keinen Zugriff mehr darauf haben, nehmen Sie bitte Kontakt auf.',
    },
    __RELATIVE_SOURCE_FILE__
);
